var _circle, _circle2, _circle3, _circle4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAchievement = function SvgAchievement(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    fill: "#fee658"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    fill: "url(#a)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    stroke: "#fff",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 120,
    height: 120,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 60,
    fill: "#6b0707"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "m52 47.6204 27.7128 16-24.5 42.4356c-1.6481 2.854-5.8477 2.602-7.1425-.429C35.2696 75.6598 28.257 88.7444 52 47.6204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "M47.5 106.04h4v2h-4zM78 106.04h4v2h-4zM98.5 94.0403h4.4v2h-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "m54 63.6204 27.7128-16 24.5002 42.4352c1.648 2.8546-.67 6.3656-3.943 5.9713l-11.9136-1.4354-4.7138 11.0355c-1.2948 3.031-5.4945 3.283-7.1426.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    stroke: "#ff6a6a",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m72.9808 64.3524-23.5 40.7036c-.8241 1.427-2.9239 1.3-3.5713-.215l-4.7139-11.0347c-.3273-.7664-1.092-1.2439-1.9135-1.213l-.1653.0128-11.9131 1.4349c-1.6363.1971-2.7957-1.5581-1.9716-2.9854l23.5-40.7032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    stroke: "#ff6a6a",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m76.9808 50.3524 23.5002 40.7032c.824 1.4273-.336 3.1825-1.9719 2.9854L86.596 92.6061c-.8274-.0997-1.6233.3238-2.0073 1.0506l-.0715.1496-4.7139 11.0347c-.6474 1.515-2.7472 1.642-3.5712.215l-23.5-40.7036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "M94 60c0 3.1484-.5196 6.1754-1.4778 9C86 58 81.8156 59.5 69.5 59.5 54.036 59.5 38 75.464 38 60s12.536-28 28-28 28 12.536 28 28"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 56,
    r: 28,
    fill: "#ff6a6a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 56,
    r: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    fillRule: "evenodd",
    d: "m63 66.0946-7.5411 3.9234c-1.4685.764-3.1764-.4848-2.8937-2.1158L54 59.6236l-6.0586-5.8443c-1.1975-1.1552-.5431-3.1823 1.1039-3.4191l8.3924-1.2068 3.7725-7.5646c.7364-1.4766 2.8432-1.4766 3.5796 0l3.7725 7.5646 8.3924 1.2068c1.647.2368 2.3014 2.2639 1.1039 3.4191L72 59.6236l1.4348 8.2786c.2827 1.631-1.4252 2.8798-2.8937 2.1158z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 4,
    x2: 124,
    y1: 4,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbe6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdb4d",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAchievement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "achievement.02995df86220e5748ef26ae415d5187c.svg";